export default __webpack_public_path__ + "static/media/Upload.38216b66.svg";